import { createCopyHook } from "@/components/Account/common/useCopyTable";
import {
  PAYMENT_COPY,
  paymentLokaliseKey,
} from "@/components/Account/payment/payment.static";

export { isDutchUi } from "@/components/Account/common/useCopyTable";

/** The payment settings copy table through Lokalise, see createCopyHook. */
export const usePaymentCopy = createCopyHook(PAYMENT_COPY, paymentLokaliseKey);
